/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';
let $ajax;

export const state = {
  monev: {},
};

export const mutations = {
  SET_DETAIL(state, newValue) {
    state.monev = newValue;
  },
};

export const actions = {
  async fetch({ rootState, commit }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/monev-dinas-rekap`,
    });

    const detail = await $ajax.get(`/`, { params: payload.params }).then((data) => data);
    commit('SET_DETAIL', detail?.data ?? []);

    return Promise.resolve(detail);
  },

  save({ rootState }, { params }) {
    const id = rootState.auth.instansi_id;
    return http.post(`psp/i/${id}/monev-dinas-rekap/update`, params);
  },
};
